import { Select, Radio, Modal, Checkbox, Typography } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { getLangList } from './i18n';

const { Option } = Select;
const { confirm } = Modal;
const { Text } = Typography;

// 把 data 中要用來當 option 中的 value 與 label 的值抓出來存成 Object，
export function getDataArray(dataList: any = [], value: string, label: string, needAll: boolean = false) {
  const dataArray = dataList.map((item: any) => {
    const dataObject = { value: value === '' ? item : item[value], label: label === '' ? item : item[label] };
    return dataObject;
  });
  const buttonT: any = getLangList('button');
  const singleAllOption = { value: '', label: buttonT.all };
  return needAll ? [singleAllOption].concat(dataArray) : dataArray;
};

// 回傳 select 中的 option
export function getOptionArray(dataList: any = [], disabledOptionValue: any = []) {
  return dataList.map((item: any, index: number) => {
    const { label, value } = item;
    const isDisabled = disabledOptionValue.indexOf(value.toString()) > -1;
    return (
      <Option key={index} value={value} disabled={isDisabled}>
        {label}
      </Option>
    );
  });
};

// 回傳 Radio.Group 中的 Radio
export function getRadioArray(dataList: any = [], style: any = {}) {
  return dataList.map((item: any) => (
    <Radio value={item.value} key={item.value} style={style}>
      {item.label}
    </Radio>
  ));
};

export const sortColumn = (a: any, b: any) => {
  const itemA = a ? a : '';
  const itemB = b ? b : '';
  return itemA > itemB ? 1 : -1;
};

export const sortChineseColumn = (a: any, b: any) => {
  const itemA = a ? a : '';
  const itemB = b ? b : '';
  return itemA.localeCompare(itemB);
};

export const getSortOrder = (sorter: any = {}) => {
  const order = sorter.order;
  switch (order) {
    case 'descend':
      return 'DESC';
    case 'ascend':
      return 'ASC';
    default:
      return '';
  }
};

export const getOrderParam = (key: string) => {
  switch (key) {
    case "ascend":
      return 'asc';
    case "descend":
      return 'desc';
    default:
      return undefined;
  }
};

export const getSortKey = (sorter: any = {}) => {
  const { order, columnKey } = sorter;
  const sortKey = (order && columnKey) ? columnKey : '';
  return sortKey;
};

export const getOnOkFunction = (handleType: string, data: any, fun: any) => {
  const okFunction = fun[handleType] ? fun[handleType] : function () { };
  return okFunction(data);
};

export const getModalTitle = (handleType: string, modalT: any, featureText: any) => {
  switch (handleType) {
    case 'update':
      return `${modalT.modal_title.update} ${featureText}`;
    case 'create':
      return `${modalT.modal_title.create} ${featureText}`;
    case 'subscribe':
      return `${modalT.modal_title.subscribe} ${featureText}`;
    case 'view':
      return `${modalT.modal_title.view} ${featureText}`;
    default:
      return '';
  }
};

export const showDelConfirm = (deleteFunction: any, text?: string) => {
  const t: any = getLangList('button');
  confirm({
    title: <Text strong>{`${text ?? t.confirm_delete}?`}</Text>,
    icon: <ExclamationCircleOutlined />,
    onOk() { deleteFunction(); },
    onCancel() { },
    okText: t.confirm,
    cancelText: t.cancel,
  });
};

export const showCheckConfirm = (checkFunction: any, buttonT: any, title: string = '', content: any = '') => {
  confirm({
    title: <Text strong>{title}</Text>,
    content,
    icon: <ExclamationCircleOutlined />,
    onOk() { checkFunction(); },
    onCancel() { },
    okText: buttonT.confirm,
    cancelText: buttonT.cancel,
    width: 550,
  });
};

export const showLogoutWarningConfirm = (onOkFunction: any, title: string = '') => {
  const modal = Modal.warning({
    title: <Text strong>{title}</Text>,
    onOk() { onOkFunction(); },
  });
  setTimeout(() => {
    modal.destroy();
    onOkFunction();
  }, 5000);
};

export const selectFilterOption = (input: any, option: any) => {
  const children = option?.children ?? '';
  return children.toLowerCase().indexOf(input.toLowerCase().trim()) >= 0;
};

export const getCheckboxArray = (dataList: any = []) => {
  return dataList.map((item: any, index: number) => {
    const { label, value } = item;
    return <Checkbox key={index} value={value}>{label}</Checkbox>;
  });
};

export const getPagination = (pageSize: number, pageNo: number, total?: number) => {
  const t: any = getLangList("button");
  const pagination = {
    pageSizeOptions: ["5", "10", "20", "50", "100"],
    pageSize,
    current: pageNo,
    total: total ?? 0,
    showSizeChanger: true, //默認超過50頁 顯示頁面選擇器
    showTotal: (total: number) => (`${t.total} ${total ?? 0} ${t.items}`),
  };
  return pagination;
};

export const getPageParamObject = (pageSize: number, pagination: any, sorter: any, stateSortParamObject: any = { sortBy: '', sortOrder: '' }, initPageNo: number = 1) => {
  const { sortBy, sortOrder } = stateSortParamObject;
  const nowSortBy = sorter ? getSortKey(sorter) : sortBy;
  const nowSortOrder = sorter ? getSortOrder(sorter) : sortOrder;
  const nowPageNo = pagination ? pagination.current : initPageNo;
  const nowPageSize = pagination ? pagination.pageSize : pageSize;
  return { sortBy: nowSortBy, sortOrder: nowSortOrder, nowPageNo, nowPageSize };
};

export const modalFromLayout = {
  labelCol: { lg: { span: 4 }, xs: { span: 24 }, sm: { span: 3 } },
  wrapperCol: { lg: { span: 20 }, xs: { span: 24 }, sm: { span: 21 } }
};